
export const getGoodsSelector = ({ goods }: State) => goods;

export const getLoadingSelector = ({ loading }: State) => loading;

export const getQuerySelector = ({ query }: State) => query;

export const getIsPriceLessSelector = ({ isPriceLess }: State) => isPriceLess;

export const getIsRatefulSelector = ({ isRatefull }: State) => isRatefull; 
